import { useHMSPeerId } from "../hms";
import { useLivekitPeerId } from "../livekit";
import { useProviderHook } from "./useProviderHook";

export const useProviderPeerId = (peerId, participantId) =>
  useProviderHook({
    hms: useHMSPeerId,
    livekit: useLivekitPeerId,
  })(peerId, participantId);
